var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action, makeObservable } from "mobx";
import { Apphandler } from "@/ipc/MainAppHandler";
import { APPEvent } from "@/events/AppEvents";
export class UIUser {
    constructor() {
        this.id = "";
        this.name = "";
        this.letrid = "";
        this.numberofmessages = 0;
        this.numberofletrs = 0;
        this.numberofcontacts = 0;
        this.numberoffiles = 0;
    }
    updateName(name) {
        this.name = name;
    }
    updateLetrid(lid) {
        this.letrid = lid;
    }
    updateNumOfMessages(no) {
        this.numberofmessages = no;
    }
    updateNumOfContacts(no) {
        this.numberofcontacts = no;
    }
    updateNumOfLetrs(no) {
        this.numberofletrs = no;
    }
    updateNumOfFiles(no) {
        this.numberoffiles = no;
    }
    updateProfileUrl(uri) {
        this.profileurl = uri;
    }
    inNumberOfLetrs() {
        this.numberofletrs++;
    }
    inNumberOfMessages() {
        this.numberofmessages++;
    }
}
__decorate([
    observable,
    __metadata("design:type", String)
], UIUser.prototype, "name", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UIUser.prototype, "letrid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UIUser.prototype, "numberofmessages", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UIUser.prototype, "numberofletrs", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UIUser.prototype, "numberofcontacts", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UIUser.prototype, "numberoffiles", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], UIUser.prototype, "profileurl", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], UIUser.prototype, "updateName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], UIUser.prototype, "updateLetrid", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], UIUser.prototype, "updateNumOfMessages", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], UIUser.prototype, "updateNumOfContacts", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], UIUser.prototype, "updateNumOfLetrs", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], UIUser.prototype, "updateNumOfFiles", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], UIUser.prototype, "updateProfileUrl", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UIUser.prototype, "inNumberOfLetrs", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UIUser.prototype, "inNumberOfMessages", null);
export class UserStore {
    constructor() {
        this.loading = false;
        this.uploadingprofilephoto = false;
        this.loadingpimage = false;
        this.profileimageid = "";
        this.userprofileloaderror = false;
        this.uploadingphoto = false;
        this.uploadid = "";
        this.header = [];
        this.username = "";
        this.useremail = "";
        this.userorg = "";
        makeObservable(this);
        APPEvent.addSubscriberForGetMyProfile((ret) => {
            var _a;
            if (ret !== undefined) {
                this.setUserProfle(ret);
                this.setUserPrfoileImageId((_a = ret.profileimageid) !== null && _a !== void 0 ? _a : 'test');
                this.setLoading(false);
            }
        });
    }
    setUserProfle(profile) {
        this.username = profile.name;
        this.useremail = profile.email;
        this.userorg = profile.orgname;
    }
    setUserProfileLoadError(erro) {
        this.userprofileloaderror = erro;
    }
    setLoadingPImage(loading) {
        this.loadingpimage = loading;
    }
    getHeader(userid) {
        const ret = {};
        this.header.forEach((h) => ret[h.key] = h.value);
        ret["X-Profile-ID"] = userid;
        ret["X-Profile-Size"] = 50 + "";
        return ret;
    }
    // public async uploadUserPhoto(path: string, size: number, type: string) {
    //     this.setUploadingProfile(true);
    //     const task: Job<ProfileJob> = {
    //         id: "",
    //         data: {path: path, size: size, type: type, uploaded: 0},
    //         type: JobType.ProfileUpload
    //     };
    //     const uid = await QueueProcessor.addNewTask("uploadphot", task);
    //     if(uid === undefined) {
    //         Alert.alert("Profile Photo", "Sorry, failed to upload new profile photo. Please try again later");
    //     }else {
    //         this.uploadid = uid;
    //     }
    // }
    getUserProfile() {
        if (this.userProfile === undefined) {
            this.setLoading(true);
        }
        // this.header = await shareLib.getRequestHeaders();
        // const ret = await ProfileService.getMyProfile();
        // if(ret === undefined) {
        //     Alert.alert("User Profile", "Sorry, failed to load your profile. Please try again later");
        // }
        // this.userProfile = ret;
        // this.setUserPrfoileImageId(this.userProfile?.profileimageid??'test');
        // this.setLoading(false);
        Apphandler.sendMessage("getmyprofile", "");
    }
    setUserPrfoileImageId(id) {
        this.profileimageid = id;
    }
    setLoading(loading) {
        this.loading = loading;
    }
    // private async checkUserProfileProgress() {
    //     const jobs = await QueueProcessor.getAllJobsForReference("uploadphot");
    //     if(jobs !== null && jobs.length > 0) {
    //         this.setUploadingProfile(true);
    //     }else {
    //         this.setUploadingProfile(false);
    //     }
    // }
    // @action
    // public setUser(user:User) {
    //     if(this.user === undefined) {
    //         this.user = new UIUser();
    //     }
    //     this.user.id = user.id;
    //     this.user.updateName(user.name);
    //     this.user.updateLetrid(user.letrid);
    //     this.user.updateNumOfContacts(user.usage.numberofcontacts);
    //     this.user.updateNumOfFiles(user.usage.numberoffiles);
    //     this.user.updateNumOfMessages(user.usage.numberofmessages);
    //     this.user.updateNumOfLetrs(user.usage.numberofletrs);
    // }
    setUploadingProfile(uploading) {
        this.uploadingphoto = uploading;
    }
    getUser() {
        return this.user;
    }
    reset() {
        this.user = undefined;
        this.setLoading(false);
    }
}
__decorate([
    observable,
    __metadata("design:type", UIUser)
], UserStore.prototype, "user", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UserStore.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UserStore.prototype, "uploadingprofilephoto", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UserStore.prototype, "userProfile", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UserStore.prototype, "loadingpimage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UserStore.prototype, "profileimageid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UserStore.prototype, "userprofileloaderror", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UserStore.prototype, "uploadingphoto", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], UserStore.prototype, "username", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], UserStore.prototype, "useremail", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], UserStore.prototype, "userorg", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserStore.prototype, "setUserProfle", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], UserStore.prototype, "setUserProfileLoadError", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], UserStore.prototype, "setLoadingPImage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], UserStore.prototype, "setUserPrfoileImageId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], UserStore.prototype, "setLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], UserStore.prototype, "setUploadingProfile", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UserStore.prototype, "reset", null);
